import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import store from './Store';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Auth from "./Auth/Auth";
//import Auth from './Auth/Auth';
import Callback from './Callback/Callback';
import {Provider} from "react-redux";

//const auth = new Auth();


ReactDOM.render(
    <Provider store={store}>
  
    <App/>
    </Provider>, document.getElementById('root'));
//- Read about this more in teh readme file- It's about caching and I was getting service-Wrokder.js not found error on Safari
// I am commenting this out for now 10-19-2025 registerServiceWorker();
